import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { RateBucketService } from '../rate-bucket.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateBucket } from '../rate-bucket';

@Component({
    selector: 'app-rate-bucket-form',
    templateUrl: './rate-bucket-form.component.html',
    styleUrls: ['./rate-bucket-form.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RateBucketFormComponent implements OnInit
{



	constructor(
		private rateBucketService: RateBucketService,

		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,

		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data)
	{
		this.formTitle = data.title,
			this.rateBucket = data.rateBucket
	}


	@Input() shortTermRentalId: number;
	@Input() featuresList = [];
	@Input() rateBucket: RateBucket;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	apiResponse: ApiResponse;
	rateBucketId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;


	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
	};

	ngOnInit()
	{
		this.formBuild();
		if (this.rateBucket)
		{
			this.form1.patchValue(this.rateBucket);
			this.rateBucketId = this.rateBucket.rateBucketId;
		}
	}


	onFormDelete()
	{
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.rateBucketId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () =>
			{
				this.formDelete()
			},
			reject: () =>
			{
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;
			this.rateBucketService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rateBucket = res.data.rateBucket;
						this.doAdd.emit(this.rateBucket);

					},
					err =>
					{
						console.log('rateBucket-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	formUpdate()
	{
		console.log('rateBucket: ' + JSON.stringify(this.form1.value));
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			this.formLoading = true;

			this.rateBucketService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rateBucket = res.data.rateBucket;
						this.doUpdate.emit(this.rateBucket);
					},
					err =>
					{
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete()
	{
		try
		{

			this.rateBucketService.delete(this.rateBucket.rateBucketId)
				.subscribe(
					res =>
					{
						console.log('rateBucket-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.rateBucket);
					},
					err =>
					{
						console.log('rateBucket-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			rateBucketId: [this.rateBucketId],
			name: ['', Validators.required],
			description: ['', Validators.required],
			flexiblePolicyToggle: [true],
		});
	}
}
